var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.homeLoading)?_c('v-content',{staticClass:"home"},[_c('home-skeleton')],1):_c('v-content',{staticClass:"home"},[(_vm.sendMsgLoading)?_c('app-loading-overlay'):_vm._e(),_c('main-banner'),_c('explore-banner'),_c('contact-banner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }